import e1a from './e1a-page-view';
import e1b from './e1b-click-nav-item';

export default {
  [e1a.type]: e1a,
  [e1b.type]: e1b,
};
